import { Trans } from '@lingui/react/macro';

import { ActivityOfType } from '@/components/activities/Activity';
import { BaseActivity, BaseActivityText } from '@/components/activities/BaseActivity/BaseActivity';
import IconPlace from '@/icons/Place.svg';

export const ArticleSubLocationSetActivity = ({
  activity,
}: {
  activity: ActivityOfType<'article_sub_location_set'>;
}) => {
  const creatorName = activity.creator?.name;

  const subLocation = activity.data.subLocation;

  return (
    <BaseActivity
      createdAt={activity.createdAt}
      icon={<IconPlace />}
      message={
        <BaseActivityText>
          {creatorName ? (
            <Trans id="activities.article_sub_location_set.message">
              <strong>{creatorName}</strong> set the sub-location to: <strong>{subLocation}</strong>
            </Trans>
          ) : (
            <Trans id="activities.article_sub_location_set.message.automatic">
              Sub-location has been automatically set to:
              <strong>{subLocation}</strong>
            </Trans>
          )}
        </BaseActivityText>
      }
    />
  );
};
